module.exports = __webpack_public_path__ + "static/media/ic-volume.2ea05c92.svg";